<ng-container *ngIf="layoutAccountData$ | async as layoutAccountData; else loading">
  <app-topbar />
  <main>
    <router-outlet />
  </main>
</ng-container>
<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
